import React, { useEffect, useRef, useState } from 'react';
import './About.css';
import { useLanguage } from './LanguageContext';
import translations from './translations';

function About() {
  const { language } = useLanguage();
  const t = translations[language];
  const sectionRef = useRef(null);
  const [scale, setScale] = useState(1.4);

  useEffect(() => {
    const handleScroll = () => {
      const section = sectionRef.current;
      if (!section) return;

      const rect = section.getBoundingClientRect();
      const windowHeight = window.innerHeight;

      // 0 = section just entered, 1 = fully in view
      const progress = 1 - rect.top / windowHeight;
      const clamped = Math.min(Math.max(progress, 0), 1);

      // Scale from 1.4 down to 1
      const newScale = 1.4 - clamped * 0.4;
      setScale(newScale);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className="about-section" ref={sectionRef}>
      <div
        className="about-img-wrapper"
        style={{ transform: `scale(${scale})` }}
      >
        <img src="/5.png" alt="About" />
      </div>

      <div className="about-text-box">
  <p>{t.aboutText}</p>
</div>
    </div>
  );
}

export default About;